import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "installation"
    }}>{`Installation`}</h1>
    <iframe width="1024" height="600" src="https://www.youtube.com/embed/M_pegwW4P60" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <p>{`For Installation, follow this section step by step.`}</p>
    <h2 {...{
      "id": "pre-packages"
    }}>{`Pre packages`}</h2>
    <p>{`At first make sure you've already installed `}<inlineCode parentName="p">{`node v10`}</inlineCode>{` and `}<inlineCode parentName="p">{`yarn`}</inlineCode></p>
    <blockquote>
      <p parentName="blockquote">{`We use the `}<inlineCode parentName="p">{`firebase function`}</inlineCode>{` on this headless project and at this moment firebase function support node 10. For that, if you use node 10 then it'll make both deployment and development in the same environment.`}</p>
    </blockquote>
    <p><img alt="NodeVersion.png" src={require("./images/NodeVersion.png")} /></p>
    <p>{`If you don't have installed node or yarn, then go to these links to install that.`}</p>
    <p><a parentName="p" {...{
        "href": "https://nodejs.org/en/"
      }}>{`https://nodejs.org/en/`}</a>{`
`}<a parentName="p" {...{
        "href": "https://yarnpkg.com/"
      }}>{`https://yarnpkg.com/`}</a></p>
    <p>{`After that, install `}<inlineCode parentName="p">{`firebase-tools`}</inlineCode>{` using this command to your terminal.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm i -g firebase-tools
`}</code></pre>
    <p>{`Then use this command to login firebase from `}<inlineCode parentName="p">{`console.`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`firebase login
`}</code></pre>
    <p>{`It'll open a prompt to your browser for permission. After provide the permission the firebase will logged in from `}<inlineCode parentName="p">{`console`}</inlineCode></p>
    <h2 {...{
      "id": "firebase"
    }}>{`Firebase:`}</h2>
    <ol>
      <li parentName="ol">{`Go to `}<a parentName="li" {...{
          "href": "https://console.firebase.google.com/"
        }}>{`firebase console`}</a>{` and create a new project`}</li>
    </ol>
    <p><img alt="FirebaseCreate.png" src={require("./images/FirebaseCreate.png")} /></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Then register the app for `}<inlineCode parentName="li">{`web.`}</inlineCode></li>
    </ol>
    <p><img alt="RegisterApp.png" src={require("./images/RegisterApp.png")} /></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`After register the app, go to the `}<inlineCode parentName="li">{`firestore database`}</inlineCode>{` section and create a database`}</li>
    </ol>
    <p><img alt="CreateDatabase.png" src={require("./images/CreateDatabase.png")} /></p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Then go to the project settings,`}</li>
    </ol>
    <p><img alt="ProjectSettings.png" src={require("./images/ProjectSettings.png")} /></p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`From that project settings page, you'll find all the firebase credentials.`}</li>
    </ol>
    <p><img alt="FirebaseConfig.png" src={require("./images/FirebaseConfig.png")} /></p>
    <p>{`Now to add this firebase credentials, rename `}<inlineCode parentName="p">{`.env.example`}</inlineCode>{` to `}<inlineCode parentName="p">{`.env`}</inlineCode>{` from,`}</p>
    <pre><code parentName="pre" {...{}}>{`packages/web/
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`packages/server/
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`packages/importer/
`}</code></pre>
    <p>{`And the add firebase config credentials to that `}<inlineCode parentName="p">{`.env`}</inlineCode></p>
    <p><img alt="AddFireConfig.png" src={require("./images/AddFireConfig.png")} /></p>
    <h2 {...{
      "id": "google-map"
    }}>{`Google Map`}</h2>
    <p>{`Follow this link and create a Google Maps API key.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developers.google.com/maps/documentation/javascript/get-api-key"
      }}>{`https://developers.google.com/maps/documentation/javascript/get-api-key`}</a></p>
    <p>{`After creating the API key, add the Key to your,`}</p>
    <pre><code parentName="pre" {...{}}>{`packages/server/.env
`}</code></pre>
    <p>{`and,`}</p>
    <pre><code parentName="pre" {...{}}>{`packages/web/.env
`}</code></pre>
    <p><img alt="AddGoogleMap.png" src={require("./images/AddGoogleMap.png")} /></p>
    <h2 {...{
      "id": "firebase-admin-config"
    }}>{`Firebase Admin Config`}</h2>
    <p>{`Go to your `}<inlineCode parentName="p">{`project settings`}</inlineCode>{` from `}<inlineCode parentName="p">{`firebase console`}</inlineCode>{` again,`}</p>
    <p>{`And then `}<inlineCode parentName="p">{`Create A New Service`}</inlineCode>{` and `}<inlineCode parentName="p">{`Generate a new private key.`}</inlineCode></p>
    <p><img alt="ServiceAccount.png" src={require("./images/ServiceAccount.png")} /></p>
    <p>{`With that, a `}<inlineCode parentName="p">{`JSON`}</inlineCode>{` will be download.`}</p>
    <p>{`Open that `}<inlineCode parentName="p">{`JSON`}</inlineCode>{` to your `}<inlineCode parentName="p">{`Code editor`}</inlineCode>{` and,`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`copy one by one credentials to your `}<inlineCode parentName="p">{`packages -> server -> config.js`}</inlineCode>{`
`}<img alt="ConfigJS.png" src={require("./images/ConfigJS.png")} /></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`And copy full `}<inlineCode parentName="p">{`json`}</inlineCode>{` to your `}<inlineCode parentName="p">{`packages -> importer -> headless-graphql-firebase-config.json`}</inlineCode>{`
`}<img alt="ConfigJson.png" src={require("./images/ConfigJson.png")} /></p>
      </li>
    </ol>
    <p>{`Then open `}<inlineCode parentName="p">{`.firebaserc`}</inlineCode>{` and add your `}<inlineCode parentName="p">{`firebase project id`}</inlineCode></p>
    <p><img alt="FireBaseProjectID.png" src={require("./images/FireBaseProjectID.png")} /></p>
    <h2 {...{
      "id": "authentication"
    }}>{`Authentication`}</h2>
    <p>{`For authentication, you've to enable `}<inlineCode parentName="p">{`authentication`}</inlineCode>{` from `}<inlineCode parentName="p">{`firebase console`}</inlineCode>{`.`}</p>
    <p><img alt="GAuth.png" src={require("./images/GAuth.png")} /></p>
    <h3 {...{
      "id": "other-config"
    }}>{`Other Config`}</h3>
    <p>{`Now, edit `}<inlineCode parentName="p">{`packages -> server -> .env`}</inlineCode>{` and edit remaining config like this`}</p>
    <pre><code parentName="pre" {...{}}>{`GRAPHQL_URL_LOCAL=http://localhost:4000

APP_FRONT_END_URL=http://localhost:3000

CURRENCY=$
`}</code></pre>
    <p>{`Then edit `}<inlineCode parentName="p">{`packages -> web -> .env`}</inlineCode>{` and edit remaining config like this,`}</p>
    <pre><code parentName="pre" {...{}}>{`GRAPHQL_URL_LOCAL=http://localhost:4000

CURRENCY=$
`}</code></pre>
    <h2 {...{
      "id": "install-npm-packages"
    }}>{`Install npm packages`}</h2>
    <p>{`Use this command from the `}<inlineCode parentName="p">{`root`}</inlineCode>{` folder to install all the node packages.`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn
`}</code></pre>
    <h2 {...{
      "id": "import-demo-data"
    }}>{`Import Demo Data`}</h2>
    <p>{`For import demo data open `}<inlineCode parentName="p">{`packages -> importer -> package.json`}</inlineCode>{` and add `}<inlineCode parentName="p">{`firebase project id`}</inlineCode>{` to `}<inlineCode parentName="p">{`sync`}</inlineCode>{` script.
`}<img alt="ImporterScript.png" src={require("./images/ImporterScript.png")} /></p>
    <p>{`Then go to your `}<inlineCode parentName="p">{`packages -> importer`}</inlineCode>{` from `}<inlineCode parentName="p">{`terminal`}</inlineCode>{` and run,`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn sync
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Sometimes for network issues, the import command failed. So if you face any error during the import, try the `}<inlineCode parentName="p">{`yarn sync`}</inlineCode>{` command a couple of times until you successfully import the data.`}</p>
    </blockquote>
    <p>{`With that, it'll import demo data to your firebase firestore DB.`}</p>
    <p><img alt="FireStoreData.png" src={require("./images/FireStoreData.png")} /></p>
    <h3 {...{
      "id": "run-project"
    }}>{`Run Project`}</h3>
    <p>{`If you set all the config properly, then run this `}<inlineCode parentName="p">{`yarn`}</inlineCode>{` command from the `}<inlineCode parentName="p">{`root`}</inlineCode>{` folder,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn start
`}</code></pre>
    <p>{`Then web server will run in localhost:3000, and graphql playground will run on localhost:4000/playground`}</p>
    <p><img alt="NodeStart.png" src={require("./images/NodeStart.png")} /></p>
    <p>{`Navigate to `}<inlineCode parentName="p">{`localhost:3000`}</inlineCode>{` in the browser to see the site.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      